import { useLocation } from "wouter";
import { Button } from "../ui/button";
import PageNotFoundImage from "@/assets/fallbacks/404-fallback.png";

/* Page Not Found component */
export const PageNotFound = () => {
  /* Hooks */
  const [, navigate] = useLocation();

  /* Render */
  return (
    <div className="flex flex-col items-center h-full">
      <img src={PageNotFoundImage} alt="Page not found" className="w-60 mb-4" />
      <h2 className="">Page not found (404)</h2>
      <p className="mt-3 text-base-content/70">Looks like you are trying to access a page that doesn&apos;t exist or the link has expired.</p>
      <p className="text-base-content/70">Please check if the address you typed is correct or contact support@dragonflyai.co for help.</p>
      <Button onClick={() => navigate("/", { replace: true })} className="mt-4">
        Go to Home
      </Button>
    </div>
  );
};
